// extracted by mini-css-extract-plugin
export default {"information":"newsInformation_information__IpLQr","title":"newsInformation_title__74JAN","text":"newsInformation_text__Smn1X"};